exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.ctrl-static-preformatted {\n\twhite-space: pre-wrap;\n}\n.truncated {\n\tdisplay: -webkit-box; /* свойство с префиксом, так как именно в таком варианте работают нижерасположенные стили */\n\t-webkit-box-orient: vertical;\n\toverflow: hidden;\n}\n", ""]);
